import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { GlobalDiscoveryService } from '../../../app/brand/global-discovery/service';
import { ErrorToast } from '../../../utils/toasters';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { InternalRoutes } from '../../../enum/InternalRoutes';
import DOMPurify from 'dompurify';

const StripeFailedPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const priceId = searchParams.get('priceId') ?? '';
    const packageName = decodeURIComponent(searchParams.get('packageName') ?? '');
    const navigateTo = () => {
        navigate(InternalRoutes.BRAND_DISCOVERY, { replace: true });
    };

    const startTrialAction = async () => {
        try {
            setLoading(true);

            const response = await GlobalDiscoveryService.stripeCreateSession(priceId);

            window.location.href = response.url;
        } catch (err) {
            await ErrorToast(err);
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center h-100 mt-4 mt-md-0">
            <div className="text-center">
                <img className="mb-2" width={90} src="/icons/pending-icon.svg" alt="Payment not compleated image" />
                <h2>{t('general.stripe.payment_failed', { packageName: packageName })}</h2>
                <p
                    className="text-muted"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            t('general.stripe.payment_failed_desc', { packageName: packageName })
                        ),
                    }}
                ></p>
                <Button onClick={navigateTo} disabled={loading} className="mr-2" variant="outline-primary">
                    {t('general.stripe.back_to_dash')}
                </Button>
                <Button onClick={startTrialAction} disabled={loading} variant="primary">
                    {t('general.stripe.try_again')}
                </Button>
            </div>
        </div>
    );
};

export default StripeFailedPage;
